export const Tags02 = ({ ...props }: React.SVGProps<SVGSVGElement>) => {
   return (
      <svg
         width="18"
         height="18"
         viewBox="0 0 18 18"
         fill="none"
         xmlns="http://www.w3.org/2000/svg"
         {...props}
      >
         <g clipPath="url(#clip0_683_4868)">
            <path
               d="M16.1432 6.21297L10.4514 0.659214C9.95719 0.164214 9.24619 -0.0780358 8.55544 0.0209642L3.38944 0.727464C2.97919 0.783714 2.69194 1.16171 2.74819 1.57196C2.80444 1.98221 3.18169 2.26871 3.59344 2.21321L8.76019 1.50671C8.98969 1.47521 9.22669 1.55396 9.39844 1.72571L15.0909 7.27946C15.8747 8.06321 15.9512 9.28946 15.3332 10.1647C15.1577 9.81446 14.9409 9.48071 14.6499 9.18971L9.04369 3.63071C8.55019 3.13721 7.84594 2.89946 7.14769 2.99246L1.98094 3.69896C1.64044 3.74546 1.37494 4.01771 1.33744 4.35971L0.763692 9.54671C0.688692 10.23 0.924192 10.8997 1.41169 11.3865L6.97369 16.9012C7.68169 17.61 8.62294 17.9992 9.62419 17.9992H9.63694C10.6434 17.9962 11.5869 17.6002 12.2942 16.884L14.6694 14.478C15.3647 13.7737 15.7142 12.8587 15.7367 11.937L16.1694 11.505C17.6132 10.0425 17.6049 7.67096 16.1454 6.21221L16.1432 6.21297ZM4.49869 7.49996C4.08469 7.49996 3.74869 7.16396 3.74869 6.74996C3.75319 5.76896 5.24419 5.76971 5.24869 6.74996C5.24869 7.16396 4.91269 7.49996 4.49869 7.49996Z"
               fill="currentColor"
            />
         </g>
         <defs>
            <clipPath id="clip0_683_4868">
               <rect width="18" height="18" fill="currentColor" />
            </clipPath>
         </defs>
      </svg>
   )
}
